import React from 'react';
import styled from '@emotion/styled';
import { ThemeSettings } from '../../theme';

interface Props {
  members?: string[];
  warning?: string[];
  realEmpty?: boolean;
}

export const MembersDisplay = (props: Props) => {
  const { members, warning, realEmpty } = props;
  if(!members?.length) {
    return realEmpty ? <></> : <>-</>;
  }

  return (
    <span>
      {members.map((m,i) => (
        <React.Fragment key={`${m}_${i}`}>
          <MemberText warning={warning?.includes(m.toUpperCase())}>{m}</MemberText>
          {i < members.length - 1 && <>, </>}
        </React.Fragment>
      ))}
    </span>
  );
}

const MemberText = styled.span<{ warning?: boolean }>`
  border: ${props => props.warning ? `1.5px solid ${ThemeSettings.colors.danger}` : "none"};
  border-radius: 8px;
  padding: ${props => props.warning ? "0px 4px" : "none"};
`;